import * as React from "react"

import type { TextProps } from "@chakra-ui/react"
import { Text } from "@chakra-ui/react"

type PagingLegendProps = {
  itemsTotal: number
  itemsPerPage: number
  selectedPage: number
} & TextProps

export const PagingLegend: React.FC<PagingLegendProps> = (props) => {
  const { itemsTotal, itemsPerPage, selectedPage, ...rest } = props
  const itemsFrom = itemsPerPage * (selectedPage - 1) + 1
  const itemsTo = Math.min(itemsFrom + itemsPerPage - 1, itemsTotal)

  return (
    <Text color="neutrals.900" userSelect="none" fontSize={14} {...rest}>
      {itemsTotal > 0
        ? `Showing ${itemsFrom} - ${itemsTo} of ${itemsTotal} results`
        : "Showing 0 results"}
    </Text>
  )
}
